import * as React from 'react'
import { useFormikContext } from 'formik'
import { FormInput, Card } from '@pareto-engineering/design-system/'
import styleNames from '@pareto-engineering/bem/exports'
import { Navigator, useConversionForm } from 'modules/components'

import './styles.scss'

const baseClassName = styleNames.base
const componentClassName = 'inline-conversion-form'

const InlineConversionForm = ({
  id,
  className: userClassName,
  style,
}) => {
  const {
    visibleInputFields,
    Content,
    currentSection,
    progressPercentage,
  } = useConversionForm()

  const { values, status } = useFormikContext()
  return (
    <Card
      progress={progressPercentage}
      progressBarColor="main"
      id={id}
      className={[
        baseClassName,
        componentClassName,
        userClassName,
      ]
        .filter((e) => e)
        .join(' ')}
      style={style}
    >
      <Card.Section className="title-section">
        <p className="h3">{currentSection.title}</p>
        {currentSection.subtitle}
      </Card.Section>
      <Card.Section className="input-section">
        {
          visibleInputFields?.map((input) => (
            <FormInput
              {...input}
              key={input.name}
            />
          ))
        }
        { Content && Content(values) }
      </Card.Section>
      {currentSection.posttext && (
        <Card.Section className="s-1 post-text span-grid">
          {currentSection.posttext}
        </Card.Section>
      )}
      {status && (
        <Card.Section className="relay-error span-grid">
          {status}
        </Card.Section>
      )}
      <Navigator className="navigator-section start-1 span-8 md-start-2 md-span-12" />
    </Card>
  )
}

InlineConversionForm.defaultProps = {
  progressBarColor:'interactive',
}

export default InlineConversionForm
